import { getCanonicalThemeBrand } from '@lib/get-canonical-theme-brand';

/**
 * String interpolation that joins the brand and variant with a hyphen, producing the complete
 * theme identifier used in the DOM and CSS token selectors
 *
 * @param themeToken - the brand name or theme token, e.g. "mypharmacy"
 * @param variant - the variant name, e.g. "primary-default"
 * @returns - the complete theme identifier, e.g. "newt-mypharmacy-primary-default"
 */
export const composeThemeToken = (
  themeToken: string | undefined,
  variant?: string | null,
): string => {
  if (!themeToken) return '';
  return `newt-${getCanonicalThemeBrand(themeToken)}${variant ? `-${variant}` : ''}`;
};
